export enum ToolsKitTypeEnum{
    Calculator="calculator",
    Crawl4AI="crawl4ai",
    Postgres="postgres",
    Sql="sql",
    Csv="csv"

}